export const DELAYS = [500, 1000, 1500, 2000];
export const getRetryDelay = (retryNum: number) => DELAYS[retryNum];

export const shouldRetryGetClassroom = ({
    retryNum,
    hasAcceptedInvitations,
    error,
}: {
    retryNum: number;
    hasAcceptedInvitations: boolean;
    error: { statusCode: number };
}) => {
    let shouldRetry = false;
    if (error.statusCode === 403 && hasAcceptedInvitations) {
        shouldRetry = true;
    } else if (error.statusCode >= 500) {
        shouldRetry = true;
    }
    return shouldRetry && retryNum < DELAYS.length;
};
